import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
  rus: (
    `
    <div style="text-align: justify;">
      
      <p class="mb-3">
        Когда я увидел свет с неба, я даже не испугался. 
        Ну и что? 
        Это меня как-то касается? 
        Пусть власти и учёные там себе разбираются. 
        Это их дело обеспечивать безопасность города; а у меня и своих дел хватает.
      </p>
      
      <p class="mb-3">
        Моё дело – проверять прослушки. 
        Они стоят возле каждого дома и слушают мысли жильцов. 
        О недостойных мыслях они сообщают Официальной Комиссии, а там уже хорошо знают, что делать с негодяями.
      </p>
      
      <p class="mb-3">
        Так вот, эти свиньи ночью ломают автоматы, и никто не знает, как им это удаётся. 
        Говорят, они используют мысленные каналы; но неужели автоматы такие дурные, что не могут защитить себя?! 
        Я вижу, что наутро у них каша в голове; ну, будто они сошли с ума: они забывают всё услышанное, не выполняют приказов… 
        Будто кто-то изменил им программу, и использовать их уже нельзя.
      </p>
      
      <p class="mb-5">
        Сегодня появилось так много поломанных аппаратов, что я минуты свободной не имел. 
        Почти все на моём участке не работают.
      </p>
      
      <p class="mb-3">
        Когда я второй раз увидел свет, он был уже низко над горизонтом, более бледный, но растянувшийся на весь небосклон; свет был голубой, 
        по краям белый, довольно яркий на вечернем небе.
      </p>
      
      <p class="mb-3">
        Я подумал, может кто-то что-то знает? 
        Но в «Общественной мысли» никакой информации об этом не появилось; а люди не могут сами о чём-то узнать, они ведь живут в Домах. 
        Только мы, надсмотрщики, имеем право ходить снаружи. 
        Нам выдают специальные костюмы, очки… так мы можем выносить условия наземной жизни, совершенно неподходящие для нормального человека. 
        Представьте себе, кто-то выдвинул идею, что Земля, сама Земля была когда-то местом, где жили люди! 
        Это с её ветрами, дождями, опасными животными и растениями! 
        Сейчас нельзя пару шагов сделать по Земле, чтобы не столкнуться с чем-то опасным. 
        А микробы, вирусы?? 
        Очевидно, что вся жизнь древнего человека была просто борьбой за жизнь; каждый её день, каждый месяц он выигрывал в вечной борьбе со смертью. 
        С естественной смертью, уточним. 
        Человек жил как животное, и как животное он умирал.
      </p>
      
      <p class="mb-3">
        Разве можно даже сравнить это с нашей жизнью, жизнью возвышенной и чистой, единственно достойной Человека? 
        Он, наконец, занял полагающееся ему место в мире и отринул все грязно-биологические свойства, прежде всего приход смерти. 
        У нас умирают только по приказу Властей! 
        Это основа цивилизованной жизни: жить по правилам и умирать по правилам.
      </p>
      
      <p class="mb-3">
        Дико, невозможно себе представить: вот человек начал работу – и в середине её вдруг умирает. 
        И дальше – ничего. 
        Люди жили как беспомощные, бесцельные частицы, крутившиеся в каком-то Броуновском движении: каждый день их несло то туда, то сюда… 
        С неупорядоченными мыслями, с неожиданной смертью – нет, человек не был тогда Человеком! 
        Только мы, с нашими Властями…
      </p>


      
      <p class="text-center bold mb-3">* * *</p>
  
  
      <p class="mb-3">
        Вдруг воздух содрогнулся, голубой огонь охватил всё небо, и от невыносимого света он закрыл глаза. 
        Больше он их не открыл. 
      </p>
  
        
      <p class="text-center bold mb-3">* * *</p>
  
  
      <p class="mb-3">
        Утром над Землёй поднялось Солнце. 
      </p>
      
      <p class="mb-3">
        Оно осветило оставленные Дома и горстку людей, одетых в защитные костюмы. 
        Люди только что вышли из Домов и растерянно, с опаской смотрели вокруг; в их глазах было удивление и разочарование.
      </p>
      
      <p class="mb-3">
        Эти люди десятилетиями боролись против Властей; они, самые выдающиеся мыслители и учёные, инженеры и техники, сумели изобрести средство, 
        то самое голубое энергетическое поле, которое разрушило автоматы, все автоматы Властей. 
        А без поддержки автоматов люди бессильны!
      </p>
      
      <p class="mb-3">
        И вот исчезла сила Властей, никто больше не проверяет ежедневно наши мысли, не предписывает нам наши действия, не управляет нашей жизнью. 
        Мы свободны!
      </p>


        
      <p class="text-center bold mb-3">* * *</p>
  
  
      <p class="mb-3">
        Вся жизнь остановилась. 
        Дома, сооружённые Властями, больше не функционировали, и люди массово умирали от отсутствия жизнеобеспечения: 
        ведь они не могли самостоятельно добывать себе пропитание. 
        Всё для них делали машины, и без них люди были беспомощны и бессильны. 
        Они не могли даже дышать воздухом Земли: искусственный воздух в Домах стал для них привычным и необходимым…
      </p>
      
      <p class="mb-3">
        Но большинство погибло в первые же часы, даже не от голода и удушья – от страха. 
        Было уничтожено всё привычное, нарушен и сломан весь порядок жизни. 
        Немногие могут пережить гибель своего мира. 
      </p>
      
      <p class="mb-3">
        Лишь несколько учёных осталось. 
        И сейчас они беспомощно смотрели на так долго и страстно ожидаемую Свободную Землю. 
        Без людей, безо всего живого, мёртвая и чуждая Земля простиралась перед ними.
      </p>
      
      <p class="mb-3">
        Они дали человечеству Свободу, Независимость и все Права Человека!
      </p>

        
      <p class="text-center bold mb-3">* * *</p>
  
  
      <p class="mb-3">
        Через некоторое время с лица Земли исчезли и развалины Домов, и в космосе осталась только пустая и чистая Земля, вращающаяся вокруг Солнца.
      </p>

    </div>
    `
  )
}

const itemName = {
  rus: `Эпизод из жизни Земли`
}

const item = {
  itemlink: getLink(itemName.rus),
  rus: {
    itemName: itemName.rus,
    itemContent: content.rus,
    itemAuthor: author.rus
  }
}

export default item;

